import { createFileRoute } from '@tanstack/react-router';

import { DocumentsTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/documents')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <DocumentsTab dealId={dealId} />;
  },
});
